
import { Vue, Component, Prop } from 'vue-property-decorator'
import { OptionRecordsDto } from '@/api/service-proxies'

@Component({
  components: {},
})
export default class PayRecord extends Vue {
  dialogVisible = false
  vipRecords = new OptionRecordsDto()

  open(recods) {
    this.vipRecords = recods
    this.dialogVisible = true
  }
}
